import React from "react";
import { ActivityEntry } from "./components/activity-entry";
import { useOrderActivityState } from "./hooks/use-order-activity-state";
export function OrderActivity({ history }) {
    const { activities } = useOrderActivityState({ history });
    return (React.createElement("div", { className: "flex flex-col gap-4 px-4 py-4" },
        React.createElement("div", { className: "text-lg" }, "Order Activity"),
        activities?.map(({ icon, label, date }, index) => (React.createElement(ActivityEntry, { key: index, icon: icon, label: label, createdAt: date })))));
}
